<ng-container *ngIf="(brokerage$ | async)?.name; else noBrokerage">
	<ng-container *ngIf="brokerage$ | async as brokerage">
		<ng-container *ngIf="showBrokerageNameAndLabel">
			<ui-skeleton-loader
				type="input"
				*ngIf="isLoading$ | async; else brokerageName"
			/>
		</ng-container>
		<div class="mt-2">
			<app-firm-card
				[name]="brokerage?.name"
				[address]="setAddress(brokerage?.address)"
				[phone]="brokerage?.phoneNumber"
				[fax]="brokerage?.faxNumber"
				[email]="brokerage?.email"
				member="BROKERAGE"
				memberType="Business"
				[hoverShadow]="hoverShadow"
				(dropdown)="brokerageDropdownOptionSelect($event)"
				[testHook]="testHooks.FirmCard"
				[skeletonLoading]="isLoading$ | async"
			>
			</app-firm-card>
		</div>
		<div class="mt-2">
			<app-broker
				[broker]="brokerage?.broker"
				[brokerage]="brokerage"
				(onSelectedBroker)="selectBroker($event)"
				(onRemoveBroker)="removeBroker($event)"
				(onCreateBroker)="createBroker($event)"
				(onFocus)="_onFocus()"
				[orientation]="orientation"
				[skeletonLoading]="isLoading$ | async"
			>
			</app-broker>
		</div>

		<ng-template #brokerageName>
			<app-icon
				*ngIf="(brokerageFieldMappings$ | async)?.fileNumber"
				[icon]="AI_ICON"
				[classes]="AI_CLASSES"
				[matTooltip]="AI_TOOLTIP"
			/>
		</ng-template>
	</ng-container>
</ng-container>

<ng-template #noBrokerage>
	<app-brokerage-search
		[label]="label"
		[isClient]="isClient$ | async"
		(onSelectedBroker)="selectBroker($event)"
		(onSelectedBrokerage)="selectBrokerage($event)"
		(onFocus)="_onFocus()"
		[orientation]="orientation"
		[skeletonLoading]="isLoading$ | async"
	></app-brokerage-search>
</ng-template>

<div class="mt-2">
	<app-input
		(debounce)="fileNumberChange($event)"
		[ngModel]="(brokerage$ | async)?.fileNumber"
		label="Reference Number"
		[labelIcon]="AI_ICON"
		[labelToolTip]="
			(brokerageFieldMappings$ | async)?.fileNumber ? AI_TOOLTIP : ''
		"
		[labelIconClasses]="AI_CLASSES"
		placeholder="Reference Number"
		[skeletonLoading]="isLoading$ | async"
		[testHook]="testHooks.FileNumber"
	></app-input>
</div>
